
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { apiUrl } from './UrlParam';
 

  class AxiosFetchData  {
    token;
    decode;
    method;
    url = apiUrl
    auth;
    headers;
    action;
    module;
     
    constructor(path,body,method, url, auth,headers){
      this.path = path;
      this.body = body;
     
      this.method = method;

      if(url != null &&   (typeof url !== 'undefined')){
         this.seturl(url)
      }

      if(auth != null &&   (typeof auth !== 'undefined')){
        this.auth(auth)
      }
     
      if(headers != null &&   (typeof headers !== 'undefined')){
        this.headers(headers)
      }
     
  }
   seturl(url){
      this.url =  url
   }

    static get(path, params, url = null){
      return new AxiosFetchData(path, params,"GET", url);
    }

    static post(path,body, url = null){
      return new AxiosFetchData(path,body, "POST", url);
    }

    static postWithAuth(path, body, url = null, auth=null, headers=null){
      return new AxiosFetchData(path,body, "POSTAUTH", url, auth, headers);
    }

    static delete(path, url = null){
      return new AxiosFetchData(path, "", "DELETE", url);
    }

    static update(path, body, url = null){
      return new AxiosFetchData(path, body,  "UPDATE", url);
    }

    static token(){
      return new AxiosFetchData("", "",  "TOKEN");
    }

    // static get(path, params, isFetching){
    //   return new AxiosFetchData(path, params, isFetching,"GET");
    // }

    // static post(path,body, isFetching){
    //   return new AxiosFetchData(path,body, isFetching, "POST");
    // }
     

    async fetch(){
      //  console.log(this.body)
        // const response = await axios.get(`${this.url}/api/${this.path}`, {params:this.body,}, {
        //     headers: {
        //       Authorization: `Bearer ${this.token}`,
            
        //     },
        //   });

          const response = await axios.get(`${this.url}/api/${this.path}`, {params:this.body,  headers: {
                            Authorization: `Bearer ${this.token}`,
                            Module : this.module
                          }});
          // var xxx = {params: {offset, q}, 
          //            headers: { token: 123 }
          //           }
         // console.log(response)
          response.token = this.token;
          response.decode = this.decoded;
          response.roleaccess = this.action;
          // console.log(response);
          this.response = response
         // return response;
    }

    async postMethod(){
    //  var response;
     // try{
        var response = await axios.post(`${this.url}/api/${this.path}`, this.body, {
          headers: {
            Authorization: `Bearer ${this.token}`,
            Module : this.module
          },
        });

        response.token = this.token;
        response.decode = this.decoded;
        response.roleaccess = this.action;
        // console.log(response);
    //  }catch(e){
     //   console.log(e);
    //    throw e;
    //  }
      
        return response;
    }

    async postWithAuthMethod(){
           var data ={
             Authorization: `Bearer ${this.token}`,
           }

           if(this.headers != null && (typeof this.headers !== 'undefined')){
              data = {...data,...this.headers} 
           }
           
           
           var response = await axios.post(`${this.url}/api/${this.path}`, this.body, {
            headers: data,
            auth: {
              username: "magnumsolusion",
              password: "dA29LafX5qGeJKwfBJkdDuzP6GAhRLmA"
            }
          });

          response.token = this.token;
          response.decode = this.decoded;
          response.roleaccess = this.action;
       
          return response;
      }

    async deleteMethod(){
      const response = await axios.delete(`${this.url}/api/${this.path}`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
            Module : this.module
          },
        });
        response.token = this.token;
        response.decode = this.decoded;
        response.roleaccess = this.action;
        // console.log(response);
        return response;
    }

   async updateMethod(){
      const response = await axios.patch(`${this.url}/api/${this.path}`, this.body, {
          headers: {
            Authorization: `Bearer ${this.token}`,
            Module : this.module
          },
        });

        response.token = this.token;
        response.decode = this.decoded;
        response.roleaccess = this.action;
        return response;
    }
 

    refreshToken = async (navigate, table = null, grid=false) => {
        try {
          
          var response = await axios.get(`${this.url}/token`);
          this.module = table
          this.token = response.data.accessToken;
       
          this.decoded = jwt_decode(response.data.accessToken);

          var action = {
            READ : true,
            CREATE :true,
            UPDATE : true,
            DELETE : true,
          }

          this.action = action;
          
          if(table && this.decoded.role.toUpperCase() != 'SUPERADMIN'){
            var userAccess =  await axios.get(`${this.url}/api/RoleAccess/${this.decoded.role}/${table}`);
            // console.log(userAccess)
            if(userAccess.data.length > 0) {
              action.READ = userAccess.data.map((item)=> item.action).includes("READ");
              action.CREATE = userAccess.data.map((item)=> item.action).includes("CREATE");
              action.UPDATE = userAccess.data.map((item)=> item.action).includes("UPDATE");
              action.DELETE = userAccess.data.map((item)=> item.action).includes("DELETE");
            
            
              if(userAccess.data.map((item)=> item.action).includes("READ") == false) {
                await navigate('/NOTFOUND')
              }
             
              this.action = action;
             
            }else{
             // localStorage.clear();
              await navigate('/NOTFOUND')
            }
          }
        
            switch(this.method){
              case "GET":
                  //return await this.fetch();
                 
                    await this.fetch();
                    const setNumberGrid = new SetNumberGrid(grid, this.response);
                    this.response.data = await setNumberGrid.getGrid()
                    return this.response
                break;
              case "POST":
                return await this.postMethod();
                break;
              case "POSTAUTH":
                return await this.postWithAuthMethod();
                break;
              case "DELETE":
                  return await this.deleteMethod();
                  break;
              case "UPDATE":
                  return await this.updateMethod();
                  break;
              case "TOKEN":
                    return this.decoded;
                    break;
              default:
                // code block
                
            }
        
          response.token = this.token;
          response.decode = this.decoded;
         
          return response;
        }catch (error) {
          //alert(error.response.status)
        
          if(error.response.status == 403 || error.response.statusText == 'Forbidden' || error.response.data == 'Forbidden') {
          //  alert('hai')
              localStorage.clear();
              await navigate('/')
          }else{
              throw error;
          }
          
        }
    };
}

class SetNumberGrid 
{
    rowsWithRowNumbers;
    constructor(isSet,response){
        if(isSet == true)
        {
        //  console.log(response)
            this.rowsWithRowNumbers =  response.data.map((row, index) => ({
                ...row,
                rowNumber: index + 1, 
            }));
           
        }else{
            this.rowsWithRowNumbers = response.data
        }
    }

     getGrid(){
        return  this.rowsWithRowNumbers;
    }


}

export default AxiosFetchData;